'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = extractModules;

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # 提取模块
 *
 * + modules可以有3中形态：数组、map 和 context
 *  * 数组 和 context 时实例名优先为displayName
 *  * map时实例名为key
 */
function extractModules(modules, getName) {
  // #! 提取模块名称，组装成Json
  getName = getName || function (module, key) {
    if (module.displayName) {
      return module.displayName;
    } else if (key) {
      module.displayName = _path2.default.basename(key, _path2.default.extname(key));
      return module.displayName;
    }
  };

  var modulesMap = {};
  var name = void 0;
  // #! 数据形式，转成Map
  if (Array.isArray(modules)) {
    modules.forEach(function (Module) {
      name = getName(Module) || Module.name;
      modulesMap[name] = Module;
    });
    // #! 如果是require.context返回的对象，则获取到所有的Module
  } else if (typeof modules.keys === 'function') {
    var context = modules;
    context.keys().forEach(function (key) {
      var Module = context(key);
      if (Module) {
        name = getName(Module, key);
        modulesMap[name] = Module;
      }
    });
  } else {
    // #! 否则就是Map
    var Module = void 0;
    for (var _name in modules) {
      if (modules[_name].default) {
        Module = modules[_name].default;
      } else {
        Module = modules[_name];
      }
      modulesMap[getName(Module, _name)] = Module;
    }
  }

  return modulesMap;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/extractModules.js
// module id = 30
// module chunks = 0